if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

show(opener) {
  /* Safety: opener loading state */
  try {
    opener.setAttribute('aria-disabled', true);
    opener.classList.add('loading');
    const spinner = opener.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
  } catch (e) {
    console.warn('BBB DEBUG: opener loading failed', e);
  }

  /* Fetch product data */
  fetch(opener.getAttribute('data-product-url'))
    .then((response) => response.text())
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

      /* Copy theme classes */
      try {
        this.productElement.classList.forEach((cls) => {
          if (cls.startsWith('color-') || cls === 'gradient') {
            this.modalContent.classList.add(cls);
          }
        });
      } catch (e) {
        console.warn('BBB DEBUG: class transfer failed', e);
      }

      /* Normal NEAT QuickAdd behavior */
      this.preventDuplicatedIDs();
      this.removeDOMElements();
      this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
      
/* === BBB: Replace Add to Cart with BBB License Modal === */
setTimeout(() => {
  // Find the real ATC button Shopify generates
  const atc =
    this.modalContent.querySelector('#bbb-open-license') ||
    this.modalContent.querySelector('button.product-form__submit') ||
    this.modalContent.querySelector('button[name="add"]');

  if (!atc) {
    console.warn('BBB: No ATC button found inside Quick Add');
    return;
  }

  // Create BBB replacement button
  const bbbBtn = document.createElement('button');
  bbbBtn.type = 'button';
  bbbBtn.className = atc.className;
  bbbBtn.id = 'bbb-open-license';
  bbbBtn.innerHTML = atc.innerHTML;

  // Replace Shopify’s ATC with BBB’s
  atc.replaceWith(bbbBtn);

  // Bind click
  bbbBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (window.BBB_openLicenseModal) {
      window.BBB_openLicenseModal(e);
    }
  });

  console.log('BBB: License modal button bound successfully');
}, 50);


      /* Reinitializing payment buttons */
      if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
      if (window.ProductModel) window.ProductModel.loadShopifyXR();

      this.removeGalleryListSemantic();
      this.updateImageSizes();

      /* ACTUALLY SHOW THE MODAL */
      super.show(opener);
    })
    .catch((e) => {
      console.error('BBB DEBUG: fetch failed', e);
    })
    .finally(() => {
      /* Remove loading state */
      try {
        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading');
        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
      } catch (e) {
        console.warn('BBB DEBUG: cleanup failed', e);
      }
    });
}


      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
